/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import Grid from '@material-ui/core/Grid';

function ButtonColumns(props) {
    return (
        <Grid
            className="no-shadow"
            container
            id="reduce-width"
            justify="center"
            spacing={2}
        >
            {props.children}
        </Grid>
    );
}

export default (ButtonColumns);
